import 'core-js/fn/string/includes';
import $ from 'jquery';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/tooltip';
import 'bootstrap/js/dist/popover';
import loadFrontend, { initFrontend } from '@cigna/cigna_digital_dcws_cigna-frontend/src/js/';
import { isExternal, setExternalLinkChecker } from '@cigna/cigna_digital_dcws_cigna-frontend/src/js/links';
import initContentController from './content-controller';
import { dynamicLinks, ageModalLink } from './dynamic-links';
import initForm from './form';

var isExternalLink = function isExternalLink(link, href, hostname) {
  return isExternal(link, href, hostname) && !hostname.includes('www.cigna.com');
};

var init = function init(err) {
  setExternalLinkChecker(isExternalLink);
  initFrontend(err);
}; // Core-js polyfill version not merged into project yet.


if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

window.addEventListener('DOMContentLoaded', function () {
  initContentController();
  dynamicLinks();
});
$(function () {
  $('[data-toggle="popover"]').popover();
  loadFrontend(init);
  initForm();
  $('#AgeModal').on('show.bs.modal', ageModalLink);
});